import { SelectorType } from '../../../components/shared/Selector/Selector';
import { NewPriceFieldRow } from '../../../models/priceRows.model';

export const TEXT_UNIT_VALUE = 'text';

export const buildNewPriceFieldRow = (name: string, unit: SelectorType, formula?: string): NewPriceFieldRow => {
  if (unit?.value === TEXT_UNIT_VALUE) return { name, isText: true };
  return { name, isText: false, unit: unit?.label, formula };
};
